<template>
  <div v-if="orderId && orderDetail">
    <vx-breadcrumb
      :list="breadcrumbList"
      @breadcrumb-click="handleBreadcrumbNavigation"
      class="custom-bread-crumb"
    />
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link
            :to="`/customers/view_customer/${$route.params.id}`"
            class="vx-row"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("customers.label.view_order") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <vx-card class="mb-base card_class">
      <div class="vx-row">
        <div class="vx-col md:w-full lg:w-full w-full">
          <ul class="horizontal-sm-btn flex mb-2 float-right">
            <!-- <li>
              <div
                class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
              >
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-x"
                  class="truncate"
                  size="small"
                  @click="disconnectPopup = true"
                  >{{ $t("customers.label.disconnect") }}</vs-button
                >
              </div>
            </li> -->
            <li>
              <div
                class="cursor-pointer flex items-center text-lg font-medium w-full"
              >
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-gift"
                  class="truncate"
                  size="small"
                  @click="applyPromoPopup = true"
                  >{{ $t("customers.label.apply_promo") }}</vs-button
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2">
          <vs-table
            stripe
            :data="orderDetail.orderData"
            class="details-table w-full"
          >
            <template>
              <vs-tr>
                <vs-td>{{ $t("customers.label.order_id") }}</vs-td>
                <vs-td>{{
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.orderId
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("customers.label.charge_cycle") }}</vs-td>
                <vs-td>{{
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.contractPeriod
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("customers.label.start_date") }}</vs-td>
                <vs-td>{{
                  getDate(
                    orderDetail &&
                      orderDetail.orderData &&
                      orderDetail.orderData.startDate
                  )
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("customers.label.order_type") }}</vs-td>
                <vs-td>{{
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.isPrepaid == "Y"
                    ? "Prepaid"
                    : "Postpaid"
                }}</vs-td>
              </vs-tr>
              <vs-tr
                v-if="
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.isPrepaid != 'Y'
                "
              >
                <vs-td>{{ $t("customers.label.invoice_till_date") }}</vs-td>
                <vs-td>{{
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.invoiceTilldate
                    ? getDate(
                        orderDetail &&
                          orderDetail.orderData &&
                          orderDetail.orderData.invoiceTilldate
                      )
                    : "NA"
                }}</vs-td>
              </vs-tr>
              <!-- <vs-tr>
                <vs-td>{{ $t("customers.label.billing_cycle") }}</vs-td>
                <vs-td>
                  {{
                    orderDetail &&
                    orderDetail.billingCycle &&
                    orderDetail.orderData.billingCycle
                      ? orderDetail &&
                        orderDetail.orderData &&
                        orderDetail.orderData.billingCycle
                      : "NA"
                  }}</vs-td
                >
              </vs-tr> -->
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2">
          <vs-table
            stripe
            :data="orderDetail.orderData"
            class="details-table w-full"
          >
            <template>
              <vs-tr>
                <vs-td>{{ $t("customers.label.plan_name") }}</vs-td>
                <vs-td>{{
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.planDescription
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("customers.label.status") }}</vs-td>
                <vs-td>{{
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.status
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("customers.label.end_date") }}</vs-td>
                <vs-td>{{
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.type !== "Postpaid" &&
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.endDate
                    ? getDate(
                        orderDetail &&
                          orderDetail.orderData &&
                          orderDetail.orderData.endDate
                      )
                    : "NA"
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("customers.label.user_action") }}</vs-td>
                <vs-td>{{
                  orderDetail &&
                  orderDetail.orderData &&
                  orderDetail.orderData.userAction
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div class="mb-6"></div>
    </vx-card>
    <div class="customer-tab">
      <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <!-- <vs-tab :label="$t('customers.label.order_services')">
            <div class="tab-text">
              <vx-card>
                <vs-table
                  :max-items="descriptionItems[0]"
                  class
                  pagination
                  :data="orderDetail.orderServices"
                  description
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header" color="primary">
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("customers.label.id") }}</vs-th>
                    <vs-th>{{ $t("customers.label.service_code") }}</vs-th>
                    <vs-th>{{ $t("customers.label.service_type") }}</vs-th>
                    <vs-th>{{ $t("customers.label.service_description") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index" v-for="(service, index) in data">
                      <vs-td :data="service.orderId">{{ service.orderId }}</vs-td>
                      <vs-td :data="service.servicecode">{{ service.servicecode }}</vs-td>
                      <vs-td :data="service.serviceType">{{ service.serviceType }}</vs-td>
                      <vs-td :data="service.serviceDescription">{{
                        service.serviceDescription
                      }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
            </div>
          </vs-tab> -->
          <vs-tab :label="$t('customers.label.price_discount')">
            <div class="tab-text">
              <vx-card class="mb-base">
                <vs-table
                  :max-items="descriptionItems[0]"
                  class
                  pagination
                  :data="orderDetail.orderPriceData"
                  description
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header" color="primary">
                    <!-- ADD NEW -->
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("customers.label.Service") }}</vs-th>
                    <vs-th>{{ $t("customers.label.Product") }}</vs-th>
                    <vs-th>{{ $t("customers.label.bill_start_date") }}</vs-th>
                    <vs-th>{{ $t("customers.label.bill_end_date") }}</vs-th>
                    <vs-th
                      v-if="
                        orderDetail &&
                        orderDetail.orderData &&
                        orderDetail.orderData.isPrepaid != 'Y'
                      "
                      >{{ $t("customers.label.invoice_till_date") }}</vs-th
                    >
                    <!-- <vs-th>{{ $t("customers.label.billing_cycle") }}</vs-th> -->
                    <vs-th>{{ $t("customers.label.price") }}</vs-th>
                    <vs-th>{{ $t("customers.label.action") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index" v-for="(price, index) in data">
                      <vs-td
                        :data="
                          orderDetail &&
                          orderDetail.orderData &&
                          orderDetail.orderData.planDescription
                        "
                        >{{
                          orderDetail &&
                          orderDetail.orderData &&
                          orderDetail.orderData.planDescription
                        }}</vs-td
                      >
                      <vs-td :data="price.service">{{
                        price.serviceDescription
                      }}</vs-td>
                      <vs-td :data="price.billStartDate">{{
                        getDate(price.billStartDate)
                      }}</vs-td>
                      <vs-td :data="price.billEndDate"
                        >{{
                          price.billEndDate === null
                            ? "-"
                            : getDate(price.billEndDate)
                        }}
                      </vs-td>
                      <vs-td
                        v-if="
                          orderDetail &&
                          orderDetail.orderData &&
                          orderDetail.orderData.isPrepaid != 'Y'
                        "
                        :data="price.invoiceTillDate"
                        >{{
                          price.invoiceTillDate === null
                            ? "-"
                            : getDate(price.invoiceTillDate)
                        }}</vs-td
                      >
                      <!-- <vs-td :data="price.billingCycle">{{
                        price.billingCycle || "-"
                      }}</vs-td> -->
                      <vs-td
                        :data="price.price"
                        v-if="
                          price.serviceDescription === 'VOICE' ||
                          price.serviceDescription === 'DATA' ||
                          price.serviceDescription === 'SMS'
                        "
                        class="price"
                      >
                        <a
                          @click="
                            popupActivo = true && fetchPriceDetails(price.id)
                          "
                          >{{ $t("customers.label.ViewRateLimit") }}</a
                        >
                        <div class="centerx">
                          <vs-popup
                            class="popup-close"
                            :title="$t('customers.label.ViewRateLimit')"
                            :active.sync="popupActivo"
                          >
                            <vs-table
                              :max-items="descriptionItems[0]"
                              :data="list"
                            >
                              <template slot="thead">
                                <vs-th>{{
                                  $t("customers.label.charge_type")
                                }}</vs-th>
                                <vs-th>{{
                                  $t("customers.label.rate_uom")
                                }}</vs-th>
                              </template>
                              <template slot-scope="{ data }">
                                <vs-tr
                                  :key="index"
                                  v-for="(item, index) in data"
                                >
                                  <vs-td :data="item.chargeType">{{
                                    item.chargeType
                                  }}</vs-td>
                                  <vs-td :data="item.rate"
                                    >{{ item.rate }}/{{ item.UOM }}</vs-td
                                  >
                                </vs-tr>
                              </template>
                            </vs-table>
                          </vs-popup>
                        </div>
                      </vs-td>
                      <vs-td :data="price.price" v-else>
                        <vs-input
                          class="font-semibold"
                          :value="price.price"
                          v-model="price.price"
                          :disabled="true"
                        />
                      </vs-td>
                      <vs-td>
                        <div
                          v-if="
                            price.serviceDescription === 'VOICE' ||
                            price.serviceDescription === 'DATA' ||
                            price.serviceDescription === 'SMS'
                          "
                        >
                          -
                        </div>
                        <div v-else>
                          <feather-icon
                            title="Update"
                            icon="RepeatIcon"
                            svgClasses="w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2 icon_row"
                            @click="updatePrice(price)"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
              <vx-card>
                <vs-table
                  :max-items="descriptionItems[0]"
                  class
                  pagination
                  :data="orderDetail.orderDiscountDatas"
                  description
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header" color="primary">
                    <!-- ADD NEW -->
                    <h4>{{ $t("customers.label.Discount") }}</h4>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("customers.label.id") }}</vs-th>
                    <vs-th>{{
                      $t("customers.label.discount_description")
                    }}</vs-th>
                    <vs-th>{{ $t("customers.label.discount_type") }}</vs-th>
                    <vs-th>{{
                      $t("customers.label.discount_start_date")
                    }}</vs-th>
                    <vs-th>{{ $t("customers.label.discount_end_date") }}</vs-th>
                    <vs-th>{{ $t("Discount Rate") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index" v-for="(discount, index) in data">
                      <vs-td :data="discount.id">{{ discount.id }}</vs-td>
                      <vs-td :data="discount.discountdescription">{{
                        discount.discountdescription
                      }}</vs-td>
                      <vs-td :data="discount.discountType">{{
                        discount.discountType
                      }}</vs-td>
                      <vs-td :data="getDate(discount.discountstartDate)">{{
                        getDate(discount.discountstartDate)
                      }}</vs-td>
                      <vs-td>{{ getDate(discount.discountEndDate) }}</vs-td>
                      <vs-td :data="discount.discountAmount">{{
                        discount.discountAmount
                      }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
            </div>
          </vs-tab>
          <vs-tab :label="$t('customers.label.order_transaction')">
            <div class="tab-text">
              <vx-card>
                <vs-table
                  :max-items="descriptionItems[0]"
                  class
                  pagination
                  :data="orderDetail.orderHistory"
                  description
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header" color="primary">
                    <!-- ADD NEW -->
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("customers.label.user") }}</vs-th>
                    <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                    <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
                    <vs-th>{{ $t("customers.label.actual_date") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index" v-for="(transaction, index) in data">
                      <vs-td :data="transaction.userName">{{
                        transaction.userName
                      }}</vs-td>
                      <vs-td :data="getDate(transaction.transactionDate)">{{
                        getDate(transaction.transactionDate)
                      }}</vs-td>
                      <vs-td :data="transaction.transactioType">{{
                        transaction.transactioType
                      }}</vs-td>
                      <vs-td :data="getDate(transaction.actualDate)">{{
                        getDate(transaction.actualDate)
                      }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
    <vx-card
      v-if="
        orderDetail &&
        orderDetail.orderPromotionDatas &&
        orderDetail.orderPromotionDatas.length > 0
      "
    >
      <vs-table
        :max-items="descriptionItems[0]"
        class
        pagination
        :data="orderDetail.orderPromotionDatas"
        description
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
      >
        <template slot="header" color="primary">
          <h4>{{ $t("customers.label.Promotion") }}</h4>
        </template>
        <template slot="thead">
          <vs-th>{{ $t("customers.label.id") }}</vs-th>
          <vs-th>{{ $t("customers.label.externalPromoId") }}</vs-th>
          <vs-th>{{ $t("customers.label.externalPromoName") }}</vs-th>
          <vs-th>{{ $t("customers.label.promoCode") }}</vs-th>
          <vs-th>{{ $t("customers.label.promoDescription") }}</vs-th>
          <vs-th>{{ $t("customers.label.featureList") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(promo, index) in data">
            <vs-td :data="promo.id">{{ promo.id }}</vs-td>
            <vs-td :data="promo.externalPromoId">{{
              promo.externalPromoId
            }}</vs-td>
            <vs-td :data="promo.externalPromoName">{{
              promo.externalPromoName
            }}</vs-td>
            <vs-td :data="promo.promoCode">{{ promo.promoCode }}</vs-td>
            <vs-td :data="promo.promoDescription">{{
              promo.promoDescription
            }}</vs-td>
            <vs-td :data="promo.featureList">
              <feather-icon
                :title="$t('inventory.label.View')"
                icon="EyeIcon"
                @click="showFeatureList(promo.promotionId)"
                svgClasses="w-5 h-5 stroke-current text-primary"
                class="icon_row"
            /></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="centerx">
      <vs-popup
        class="popup-close visible"
        :title="$t('customers.label.ApplyPromo')"
        :active.sync="applyPromoPopup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <small class="font-semibold">{{
                $t("customers.label.start_date")
              }}</small>
              <datepicker
                :placeholder="$t('placeholder.label.SelectDate')"
                v-model="promo.startDate"
                class="mb-2 font-semibold"
              />
            </div>
            <div class="vx-col sm:w-full w-full">
              <small class="font-semibold">{{
                $t("customers.label.promotion")
              }}</small>
              <v-select
                label="promotionDescription"
                v-model="promo.orderPromotion"
                :options="promotionCode"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(name) => name.id"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="applyPromoPopup = false">{{
                $t("customers.label.cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="applyPromo">{{
                $t("customers.label.submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        class="popup-close visible"
        :title="$t('customers.label.Disconnect')"
        :active.sync="disconnectPopup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <small class="font-semibold">{{
                $t("customers.label.disconnection_date")
              }}</small>
              <datepicker
                :placeholder="$t('placeholder.label.SelectDate')"
                v-model="disconnectObj.startDate"
                class="mb-2 font-semibold"
              />
            </div>
            <div class="vx-col sm:w-full w-full">
              <small class="font-semibold">{{
                $t("customers.label.disconnection_reason")
              }}</small>
              <v-select
                label="mCodeValue"
                v-model="disconnectObj.disconnectDetails"
                :options="disconnectData"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(mCodeValue) => mCodeValue.id"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
            <div class="vx-col sm:w-full w-full">
              <small class="font-semibold">{{
                $t("customers.label.description")
              }}</small>
              <vs-textarea v-model="disconnectObj.description" />
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="disconnectPopup = false">{{
                $t("customers.label.cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="applyPromo">{{
                $t("customers.label.submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
      <vs-popup
        :title="$t('customers.label.featureList')"
        :active.sync="featureListPopup"
        class="popup-close small-popup"
      >
        <div class="pt-4 pb-8" v-html="featureHtml"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import VxBreadcrumb from "@/layouts/components/VxBreadcrumb.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      breadcrumbList: [
        { name: "Dashboard", path: "/dashboard" },
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.id}`,
        },
        { name: "View Order" },
      ],
      orderId: null,
      clentId: null,
      list: null,
      popupActivo: false,
      descriptionItems: [5, 10, 15],
      activeTab: 0,
      discount: {
        price: "",
      },
      promo: {
        startDate: null,
        orderPromotion: "",
      },
      disconnectObj: {
        startDate: null,
        disconnectDetails: "",
        description: "",
      },
      applyPromoPopup: false,
      disconnectPopup: false,
      featureListPopup: false,
      featureHtml: "",
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    VxBreadcrumb,
  },
  computed: {
    orderDetail() {
      return this.$store.getters["customerOrder/getOrderDetail"];
    },
    promotionCode() {
      return this.$store.getters["customerOrder/getOrderPromotion"];
    },
    disconnect() {
      return this.$store.getters["customer/getOrderDisconnect"];
    },
    ...mapState({
      disconnectData: (state) => state.customerOrder.disconnectData,
      formattedDate: (state) => state.settings.selectedDateFormat,
      featureList: (state) => state.customer.promotionFeatureList,
      clientDetail: (state) => {
        const storedClientDetail = JSON.parse(
          localStorage.getItem("clientDetail")
        );
        return storedClientDetail || state.customer.clientDetailData;
      },
    }),
  },
  methods: {
    handleBreadcrumbNavigation() {
      //
    },
    async fetchPriceDetails(id) {
      const res = await this.$store.dispatch(
        "customerOrder/fetchPriceData",
        id
      );
      this.list = (res && res.data) || null;
    },
    async getOrder() {
      try {
        await this.$store.dispatch(
          "customerOrder/setOrderDetail",
          this.orderId
        );
      } catch (error) {
        console.log(
          "something went to wrong while retrieving entity by id:",
          error
        );
      }
    },
    showFeatureList(id) {
      this.$store.dispatch("customer/setFeatureList", id).then((res) => {
        const temp = this.featureList.find(
          (item) => item.type === "Feature_list"
        );
        this.featureHtml = temp.text;
        this.featureListPopup = true;
      });
    },
    async getOrderPromotion() {
      try {
        this.$store.dispatch("customerOrder/setOrderPromotion");
      } catch (error) {
        console.log(
          "something went to wrong while retrieving entity by id:",
          error
        );
      }
    },
    async getOrderDisconnect() {
      try {
        this.$store.dispatch("customerOrder/getDisconnectPlans");
      } catch (error) {
        console.log(
          "something went to wrong while retrieving entity by id:",
          error
        );
      }
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async updatePrice(price) {
      try {
        price.locale = "en";
        await this.$store.dispatch("customer/updateOrderPrice", {
          id: this.orderId,
          data: price,
        });
        this.getOrder();
      } catch (error) {
        console.log(
          "something went to wrong while retrieving Order by id:",
          error
        );
      }
    },
    async applyPromo() {
      const payload = {
        id: this.orderId,
        data: {
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          promoId: this.promo.orderPromotion,
          startDate: this.promo.startDate,
        },
      };
      await this.$store.dispatch("customer/applyPromoAction", payload);
      this.applyPromoPopup = false;
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Applied Promo Successfully!",
        type: "success",
      });
    },
    async disconnectPlan() {
      let planArray = [];
      for (let temp of this.selectedCancelPlans) {
        planArray = [
          ...planArray,
          {
            id: temp.id,
            planDescription: temp.planDescription,
            orderNo: temp.orderNo,
            planPoId: temp.planPoId,
            dealPoId: temp.dealPoId,
            clientServiceId: this.clientServiceId,
            disconnectReason: this.disconnectPlanObj.disconnectReason,
            description: this.disconnectPlanObj.description,
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            disconnectionDate: moment().format("DD MMMM YYYY"),
          },
        ];
      }

      try {
        let payload = { plans: planArray };
        await this.$store.dispatch("customer/cancelPlansAction", {
          id: this.$route.params.id,
          data: payload,
        });
        this.disconnectPlanObj = {
          disconnectReason: "",
          description: "",
        };
        this.cancelPlansPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Plans Cancelled Successfully!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.warningText = "";
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
  },
  mounted() {
    this.orderId = this.$route.params.orderId;
    this.getOrder();
  },
  watch: {
    applyPromoPopup(newValue) {
      if (newValue) {
        this.getOrderPromotion();
        this.promo.startDate = moment().format("DD MMMM YYYY");
      }
    },
    disconnectPopup(newValue) {
      if (newValue) {
        this.getOrderDisconnect();
        this.disconnectObj.startDate = moment().format("DD MMMM YYYY");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.price {
  cursor: pointer;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  background-color: rgba(var(--vs-primary), 0.1);
  padding: 0.6rem 1.5rem !important;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  text-transform: capitalize;
  font-weight: 600 !important;
  font-size: 16px !important;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 0.9rem 1.8rem !important;
}
</style>
